const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export async function fetchPeethas() {
  const response = await fetch(`${API_BASE_URL}/api/peethas`);
  if (!response.ok) {
    throw new Error("Failed to fetch peethas");
  }
  return response.json();
}

export async function fetchPeethaBySlug(slug) {
  const response = await fetch(`${API_BASE_URL}/api/peethas/${slug}`);
  if (!response.ok) {
    throw new Error("Failed to fetch peetha");
  }
  return response.json();
}
